import { useEffect, useMemo, useState } from 'react';
import { getAcademicYearOptions, getAcademicYearRange } from './academicYear';

const MAX_TIMEOUT_DELAY = 2147483647;

const useAcademicYearOptions = ({
  asOfDate,
  previousYears = 0,
  futureYears = 0,
}) => {
  const [currentDate, setCurrentDate] = useState(() =>
    asOfDate === undefined ? new Date() : new Date(asOfDate)
  );

  useEffect(() => {
    if (asOfDate !== undefined) {
      setCurrentDate(new Date(asOfDate));
      return undefined;
    }

    let timeoutId;
    const scheduleRolloverCheck = () => {
      const now = new Date();
      setCurrentDate(now);
      const delay = Math.min(
        Math.max(getAcademicYearRange(now).end.getTime() - now.getTime() + 50, 1000),
        MAX_TIMEOUT_DELAY
      );
      timeoutId = setTimeout(scheduleRolloverCheck, delay);
    };

    scheduleRolloverCheck();
    return () => clearTimeout(timeoutId);
  }, [asOfDate]);

  return useMemo(
    () => getAcademicYearOptions({ asOfDate: currentDate, previousYears, futureYears }),
    [currentDate, previousYears, futureYears]
  );
};

export default useAcademicYearOptions;
